<template lang="pug">
.footer-container(:class="white ? 'white' : ''")
  //- .tracking(:class="trackClass" @click="disable") {{ tracking }}
  .container
    span.copyright © 2020 Moonly® by NopeStudio |&nbsp;
    span.terms-link(@click="$router.push('/terms-conditions-website')" title="Conditions Générales d'Utilisation") CGU
</template>

<script>
export default {
  name: 'Footer',
  // data: () => ({
  //   tracking: 'Désactiver le suivi par Google Analytics',
  //   trackClass: 'clickable'
  // }),
  props: ['white'],
  methods: {
    //   disable () {
    //     this.$ga.disable()
    //     this.tracking = 'Le suivi par Google Analytics a été désactivé :)'
    //     this.trackClass = ''
    //   }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/colors';
@use '@/styles/text';

.footer-container {
  padding: {
    top: 100px;
    bottom: 20px;
  }
  color: colors.$grey-text;

  &.white {
    color: white;
  }

  .email {
    @include text.small;
    text-align: center;
    margin-bottom: 10px;
  }

  .container {
    text-align: center;
  }

  .terms-link:hover,
  .email:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  // .tracking {
  //   text-align: center;

  //   &.clickable:hover {
  //     cursor: pointer;
  //     text-decoration: underline;
  //   }
  // }
}
</style>
